import { render, staticRenderFns } from "./notsignedin-layout.vue?vue&type=template&id=51494ffb"
import script from "./notsignedin-layout.vue?vue&type=script&lang=js"
export * from "./notsignedin-layout.vue?vue&type=script&lang=js"
import style0 from "./notsignedin-layout.vue?vue&type=style&index=0&id=51494ffb&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports